// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cv-button[data-v-aa4ac25c]:active,.cv-button[data-v-aa4ac25c]:focus,.cv-button[data-v-aa4ac25c]:hover{outline:none!important;background:#e0e0e0!important;border:none!important}", ""]);
// Exports
module.exports = exports;
